import { useLayoutEffect, useRef, useState } from 'react';
import { Breakpoints, useBreakpoint, useTranslation } from '@nextgen-web-framework/all';
import { BannerProps } from './types/propTypes';
import { fontConfigMap } from './BannerConfig';
import styles from './Banner.module.scss';

const Banner = ({ searchedKeyword, originallySearchedText, hasSearchResult }: BannerProps) => {
  const [textClass, setTextClass] = useState('');
  const searchedTextRef = useRef<HTMLParagraphElement>(null);
  const t = useTranslation();
  const viewPortType = useBreakpoint() as Breakpoints;
  const isMobile = [Breakpoints.XS, Breakpoints.SM].includes(viewPortType);

  useLayoutEffect(() => {
    const callback = () => {
      if (searchedKeyword && searchedTextRef.current) {
        const fontConfigs = fontConfigMap[isMobile ? 'mobile' : 'desktop'];
        const width = searchedTextRef.current.clientWidth;
        const { fontFamily } = getComputedStyle(searchedTextRef.current);
        const paraElem = document.createElement('p');
        paraElem.innerText = `“${searchedKeyword}”`;
        document.body.append(paraElem);

        for (let i = 0; i < fontConfigs.length; i++) {
          let flag = false;
          if (fontConfigs[i].default) {
            flag = true;
          } else {
            paraElem.setAttribute(
              'style',
              `width:${width}px;font-family:${fontFamily};font-size:${fontConfigs[i].fontSize};line-height:${fontConfigs[i].lineHeight};font-weight:700;visibility:hidden`,
            );
            const height = paraElem.clientHeight;
            const lines = Math.floor(height / parseInt(fontConfigs[i].lineHeight));
            flag = lines <= (fontConfigs[i].maxLine as number);
          }
          if (flag) {
            setTextClass(styles[fontConfigs[i].className]);
            break;
          }
        }
        paraElem.remove();
      }
    };

    callback();
    window.addEventListener('resize', callback);
    return () => window.removeEventListener('resize', callback);
  }, [searchedKeyword, searchedTextRef, isMobile]);

  return (
    <div className={`${styles['banner-container']} ${!hasSearchResult ? styles.noResult : ''}`}>
      <div className={styles.text}>
        <span>{t('search.banner.resultsFor')}</span>
        <p ref={searchedTextRef} className={textClass}>
          {searchedKeyword && `“${searchedKeyword}”`}
        </p>
      </div>
      {originallySearchedText && (
        <div className={styles['original-text']}>
          <span>{t('search.banner.noResultsFor')}</span>
          <span>{originallySearchedText}</span>
        </div>
      )}
    </div>
  );
};

export default Banner;
